<span class="label" *ngIf="label" >{{label}}</span>

<div class="cursor" *ngIf="!isDisabled && cursor; else disabledBlock">
    <button mat-raised-button mat-icon-button
        class="calc-button"
        color="primary"
        (click)="onButtonClick('-')">
        <mat-icon aria-label="Less button">remove</mat-icon>
    </button>

    <div class="value-container" *ngIf="!allowInput">
        <span *ngIf="cursor.offset" class="value-second">{{formatValue(cursor.offset, false)}}</span>
        <span class="value">{{formatValue(value, true)}}</span>
    </div>

    <form class="value-container" *ngIf="allowInput"
        [formGroup]="cursorForm">
        <mat-form-field *ngIf="mode !== indiceMode.amount">
            <span *ngIf="cursor.offset" matPrefix> {{formatValue(cursor.offset, false)}} + </span>
            <input matInput type="number" inputmode="numeric" name="indice" formControlName="indice" step="0.01" onclick="this.select()">
            <span *ngIf="mode === indiceMode.percent" matSuffix> %</span>
        </mat-form-field>

        <mat-form-field *ngIf="mode === indiceMode.amount">
            <input matInput type="text" name="amount" formControlName="amount"
            (focus)="onShowValue()" (blur)="onEmitValue()" onclick="this.select()">
            <span matSuffix> €</span>
        </mat-form-field>
    </form>

    <button mat-raised-button mat-icon-button
        class="calc-button"
        color="primary"
        (click)="onButtonClick('+')">
        <mat-icon aria-label="More button">add</mat-icon>
    </button>
</div>

<ng-template #disabledBlock>
    <div class="cursor">
        <div *ngIf="!isNotEditable" class="text-container">
            <span class="value">{{ 'main.cursor.edited.shortLabel' | translate}}</span>
        </div>
        <div *ngIf="isNotEditable" class="text-container">
            <span class="value">{{ 'main.cursor.notEditable.shortLabel' | translate}}</span>
        </div>
    </div>
</ng-template>

